// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1TdQg","playContainer":"styles_playContainer__3O5zx","duration":"styles_duration__2SJFd"};